import sanitizeHtml from 'sanitize-html';

/**
 * [createSanitizedHtmlObject]
 * Returns sanitized a html object when passed html
 */
export const createSanitizedHtmlObject = (storyHtml: any) => {
  return {
    __html: sanitizeHtml(storyHtml),
  };
};
